export const categorySampleData = {
  "brands": [
    {
      "name": "Hull University",
      "composite_score": 78,
      "category_scores": [80, 75, 65, 55, 65, 75, 60, 55, 70],
      "is_your_brand": true
    }
  ],
  "chart_data": {
    "composite_score": {
      "value": 78,
      "label": "Moderate AI Visibility",
      "color": "#2196f3",
      "brand": "Hull University (YOU)"
    },
    "ai_category_insights": {
      "title": "AI Category Insights by Subject Area",
      "type": "combo-chart-v2",
      "x_axis": [
        "Arts, Humanities & Social Sciences",
        "Business & Management",
        "STEM",
        "Health & Medical Sciences",
        "Education & Training",
        "Law, Legal & Public Services",
        "Creative Arts & Design",
        "Hospitality, Tourism",
        "Agriculture & Environmental Studies"
      ],
      "series": [
        {
          "name": "Hull University",
          "type": "line",
          "data": [80, 75, 65, 55, 65, 75, 60, 55, 70]
        }
      ]
    },
    "ai_table_summary": {
      "title": "AI Visibility Table by Category",
      "headers": ["Category", "Score"],
      "rows": [
        ["Arts, Humanities & Social Sciences", 80],
        ["Business & Management", 75],
        ["STEM", 65],
        ["Health & Medical Sciences", 55],
        ["Education & Training", 65],
        ["Law, Legal & Public Services", 75],
        ["Creative Arts & Design", 55],
        ["Hospitality, Tourism & Services", 65],
        ["Agriculture & Environmental Studies", 70]
      ]
    },
    "category_demand": {
      "title": "Category AI Performance (Demanding Categories)",
      "type": "combo-chart-v2",
      "series": [
        { "name": "Arts, Humanities & Social Sciences", "value": 60, "rate": 2.5, "forecast": 2 },
        { "name": "Creative Arts & Design", "value": 70, "rate": 3.2, "forecast": 5 },
        { "name": "Hospitality, Tourism", "value": 65, "rate": 2.8, "forecast": 4 },
        { "name": "Agriculture & Environmental Studies", "value": 60, "rate": 2.1, "forecast": 3 }
      ]
    },
    "subject_demand_analysis": {
      "title": "Subject Demand Analysis",
      "type": "combo-chart-v2",
      "series": [
        {
          "name": "Hull University",
          "data": {
            "Teaching Quality": 55,
            "Academic Reputation": 65,
            "Placement rate": 45,
            "International Outlook": 85,
            "Resources & Infrastructure": 65,
            "Industry & Knowledge Transfer": 85,
            "AI mention": 90,
            "AI Sentiment": 54,
            "AI cited domains": 65,
            "AI page Index": 55,
            "Domestic course fees": "£9,000",
            "International course fees": "£12,000",
            "Average salary": "£25,000"
          }
        }
      ]
    },
    "university_info": {
      "academic_reputation": 89,
      "domestic_employment_demand": 70,
      "international_student_sentiment": 85,
      "domestic_course_fees": 7000,
      "international_employment_demand": 80,
      "placement_rate": 90,
      "international_course_fees": 12000,
      "average_salary": 24000,
      "prediction_next_5y": "Growing"
    },
    "recommendations": {
      "strengths": [
        "Strong AI mentions across STEM",
        "Competitive domestic tuition"
      ],
      "weaknesses": [
        "Moderate subject diversification in Arts",
        "Lower placement rate in STEM"
      ]
    }
  },
  "context": {
    "analysis_type": "AI Category Performance",
    "category": "Technology",
    "region": "North America",
    "total_brands_analyzed": 1
  },
  "timestamp": "2024-01-15T10:30:00Z",
  "model_meta": {
    "model": "gpt-4",
    "response_time": 1.5
  },
  "citations": [
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=AI+Visibility+University+Rankings+2025",
      "title": "Search Results for AI Visibility Rankings",
      "snippet": "Search results for AI Visibility university comparisons 2025",
      "confidence": 0.7
    }
  ]
};
